// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {handleSend, sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	const [loaded, setLoaded] = React.useState(false);
	const [types, setTypes] = React.useState([]);
	//const [changed, setChanged] = React.useState(false);
	//const [saveLabel, setSaveLabel] = React.useState('Save');
	const basicvars = ['ip', 'serialNumber', 'location', 'description', 'sign_type', 'sign_type_obj'];
	const [basic, setBasic] = React.useState({
		ip: '',
		serialNumber: '',
		location: '', //Name
		description: '',
		sign_type_obj: {},
		sign_type: 0,
	});
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			var bds = {};
			basicvars.forEach((bd) => bds[bd] = sign[bd]);
			setBasic(bds);
		}
		if(!loaded){
			getTypes();
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sign, loaded, signId]);
	
	const getTypes = () =>{
		setLoaded(true);
		handleSend({
			vso: 'typeslist'
		}, (data) => {
			console.log(data);
			setTypes(data.types);
			//setBTypesList(data.btypes);
			//setCategories(data.categories);
			//setImages(data.images);
		});
	};
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, basic);
		
		//if numeric
		/*
		if([
			'opt_height', 
			'opt_width',
			'opt_digits'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > limits[name]){
				value = limits[name];
			}
		}
		*/
		
		newDetails[name] = value;
		setBasic(newDetails);
		if(onChange){
			console.log('Somethings Changed!');
			onChange(newDetails);
		}
		//setChanged(true);
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title={basic.location} />
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_location"
							name="location"
							label="Name"
							value={basic.location}
							type="text"
							inputProps = {{
									  maxlength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="sign_description"
							name="description"
							label="Description"
							multiline
							maxRows={4}
							value={basic.description}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="sign_ip"
							name="ip"
							label="IP/Modem ID"
							value={basic.ip}
							type="text"
							inputProps = {{
									  maxlength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						<TextField
							id="sign_serial"
							name="serialNumber"
							label="Serial Number"
							value={basic.serialNumber}
							type="text"
							inputProps = {{
									  maxlength:"25"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
						
						
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_type"
							name="sign_type"
							label="Type"
							value={basic.sign_type}
							onChange={handleChangeValue}
							fullWidth
							select
						>
							{types.map((row) => (
							<MenuItem value={row.id} key={row.id}>
								<Box className={classes.signTypeItem}
									direction="row"
									alignItems="flex-end"
									justifyContent="center"
									style={{
										backgroundImage:'url("http://forteltraffic.com/'+row.pic_path+'")'
									}}
								>
	  		  	  					<Typography style={{paddingTop:158}}>{row.name}</Typography>
	  	  	  					</Box>
							</MenuItem>
							))}
						</TextField>
					</Grid>
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
